const CallToActionBanner = () => {
  return (
    <div className="px-4 max-w-7xl m-auto my-5">
      <div className="border border-[#0047ff]/25 bg-[#0047ff]/8 backdrop-blur-md rounded-2xl px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-5 shadow-md">
        <div>
          <p className="text-[9px] font-black tracking-[0.2em] uppercase text-[#0047ff]/90 mb-1">
            Lokult – För all musik ifrån Strängnäs kommun
          </p>
          <h2 className="text-lg md:text-xl font-bold text-white">
            Är du artist eller med i ett band?
          </h2>
          <p className="text-stone-300/90 mt-1 max-w-xl text-xs md:text-sm leading-relaxed">
            Skapa en profil och gör din musik synlig för hela Strängnäs. Det är
            helt gratis så klart!
          </p>
        </div>
        <a href="/register" className="shrink-0">
          <button className="btn btn-outline btn-sm border-[#0047ff]/30 text-white hover:bg-[#0047ff] hover:border-[#0047ff] hover:text-white rounded-full font-bold uppercase tracking-wider text-[10px] px-5 h-9 min-h-0 shadow-sm transition-all duration-300 hover:scale-105">
            Skapa profil
          </button>
        </a>
      </div>
    </div>
  );
};

export default CallToActionBanner;
